import React, { memo } from "react"
import styled from "styled-components"
import { News } from "./news.interface"
import { NeutralTextLink } from "../link/link.styled"
import { Image } from "../../../components/common/image.component"
import { generateSources } from "../../../helpers/images"
import { AppFunctionComponent } from "../../../types"
import { css } from "styled-components"
import { Link } from "gatsby"

const NewsBox = styled.li<{ $fullHeight?: boolean }>`
  width: 100%;
  display: flex;
  max-width: 390px;
  height: 461px;
  overflow: hidden;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.color.border};
  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      height: 100%;
    `}
`

const NewsHeading = styled.div`
  /* Heading/H5 */
  font-family: Facto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 25.2px */
  text-align: left;
`

const NewsImage = styled(Image)`
  height: 285px;
  width: 100%;
  background-size: cover;
  background-position: center;

  img {
    object-fit: cover;
    object-position: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    height: 0;
    padding-bottom: 78%;
  }
`

const NewsContent = styled.div`
  flex: 1;
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
`

const NewsCategory = styled.div`
  color: #aaa;

  /* Text/Small/Semi Bold */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
`

const NewsStats = styled.div`
  margin-top: 8px;
  /* Text/Small/Medium */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
`

const NewsHeadingLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  &:hover {
    color: ${({ theme }) => theme.color.linkHover};
  }
`

const NewsItemMinimalist: AppFunctionComponent<News> = memo(
  ({
    fullHeight,
    link,
    title,
    postOriginalPublishDate,
    postTags,
    mobileImage,
    desktopImage,
  }) => {
    const date = new Date(postOriginalPublishDate).toLocaleDateString("en-us", {
      month: "short",
      year: "numeric",
      day: "numeric",
    })
    return (
      <NewsBox $fullHeight={fullHeight}>
        <NeutralTextLink to={`/community/blog/${link}`}>
          <NewsImage
            image={generateSources([[desktopImage], [mobileImage, 768]])}
          />
        </NeutralTextLink>
        <NewsContent>
          <NewsCategory>{postTags[0].text}</NewsCategory>
          <NewsHeadingLink to={`/community/blog/${link}`}>
            <NewsHeading>{title}</NewsHeading>
          </NewsHeadingLink>
          <NewsStats>{date} • 5 min read</NewsStats>
        </NewsContent>
      </NewsBox>
    )
  }
)

export default NewsItemMinimalist
